import { Images } from 'lucide-react';
import { LinkBase, useRecordContext, useTranslate } from 'ra-core';
import { buttonVariants } from '../../components/ui/button';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { NudgeInputs, nudgeFormDefaultValues } from './NudgeInputs';

export const NudgeEdit = () => (
  <MoonstarEdit redirect="list" hideDelete actions={<NudgeEditActions />}>
    <MoonstarEditForm defaultValues={nudgeFormDefaultValues}>
      <NudgeInputs />
    </MoonstarEditForm>
  </MoonstarEdit>
);

const NudgeEditActions = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  return (
    <LinkBase
      to={`/nudges/${record?.id}/slides`}
      className={buttonVariants({ variant: 'outline' })}
    >
      <Images />
      {translate('resources.nudges.fields.nudgeSlides')}
    </LinkBase>
  );
};
